import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AuthGate from "./AuthGate";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthGate>
    <App />
  </AuthGate>
);